import { windowStyle } from "@/constants/Category";
import { createContext, useEffect, useState } from "react";

export const WinContext = createContext({
    app: "webapp"
})
export function WindowThemeProvider({ children }: any) {
  const [app, setApp] = useState<any>('webapp');

  const checkIsWindow = () => {
    try {
        if (window && window.require) {
            const { ipcRenderer } = window.require('electron');
            setApp('window');
            const myRootDiv = document.getElementsByTagName('html');
            const oldStyle = myRootDiv[0]?.getAttribute('style');
            const styles = oldStyle ? oldStyle + "; " + windowStyle : windowStyle;
            myRootDiv[0]?.setAttribute('style', styles);
            return;
        }
    } catch {
        setApp('webapp');
    }
}

  useEffect(() => {
    checkIsWindow();
  },[]);

  return (
    <WinContext.Provider value={{app}}>
        {children}
    </WinContext.Provider>
  )
}